export function tc(name) {
  const v = getComputedStyle(document.documentElement).getPropertyValue(`--c-${name}`).trim();
  return v || "#888888";
}

export const THEME_TOKENS = ["bg", "surface", "border", "text", "muted", "accent", "green", "amber", "red"];
